


import Footer from "../../Foot/Foot";
import AlsoUs from "../../LandComponents/AlsoUs/AlsoUs";
import HeroHome from "../../LandComponents/HeroHome/HeroHome";
import HeroSection from "../../LandComponents/HeroSection/HeroSection";
import NavHome from "../../LandComponents/NavHome/NavHome";
import OurPricing from "../../LandComponents/OurPricing/OurPricing";
import OurWork from "../../LandComponents/OurWork/OurWork";
import Steps from "../../LandComponents/Steps/Steps";
import Stories from "../../LandComponents/Stories/Stories";
import "./Landing.css"

function Landing(){  
    return <>
    <div className="">

                        {/* <NavHome/> */}
                        <HeroHome/>
                        <Steps/>
                                                                      

                        <AlsoUs/>
                        <Stories/>
                        <OurPricing/>
                        <Footer/>
                        
                      
                     

                     {/* <HeroSection/> */}

     
        </div>
        
    </>

}

export default Landing;